<template>
  <div class="overlay">
    <button ref="dummy" class="dummy"></button>
    <div class="outer_dialog">
      <div class="outer_round" :style="{ 'background-color': color }"></div>
      <div class="inner_round" :style="{ 'background-color': color }">
        <img src="../assets/images/usklicnici/usklicnik.svg" alt="" />
      </div>
      <div class="dialog">
        <div class="title">{{ title }}</div>
        <div v-if="single" class="footer">
          <div @click="click(false)" class="whole" :style="{ 'background-color': color }">{{ right }}</div>
        </div>
        <div v-else class="footer">
          <div @click="click(true)" class="left" :style="{ 'background-color': color }">{{ left }}</div>
          <div @click="click(false)" class="right">{{ right }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.dummy {
  border: none;
}
.overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(77, 77, 77, 0.9);
  z-index: 100000;
}

.outer_dialog {
  position: relative;
  max-width: 500px;
}

.dialog {
  width: 86vw;
  max-width: 500px;
  background: $darker_background;
  box-shadow: 0 25px 40px 20px rgba(0, 0, 0, 0.24);
  border-radius: 30px;
  overflow: hidden;
}

.outer_round {
  position: absolute;
  max-width: 145px;
  max-height: 145px;
  width: 25vw;
  height: 25vw;
  left: 50%;
  top: 0;
  border-radius: 50%;
  opacity: 0.45;
  transform: translate(-50%, -50%);
}

.inner_round {
  position: absolute;
  max-width: 104px;
  max-height: 104px;
  width: 18vw;
  height: 18vw;
  left: 50%;
  top: 0;
  border-radius: 50%;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translate(-50%, -50%);
}

.title {
  margin-top: 16%;
  margin-bottom: 7%;
  font-size: 1.6rem;
  line-height: 1.5;
  letter-spacing: 0.4px;
  text-align: center;
  color: $text_dark;
  padding: 0 6vw;
}

.footer {
  display: flex;
  text-align: center;
  font-size: 1.8rem;
  line-height: 1.33;
  letter-spacing: 0.45px;
  cursor: pointer;

  .left {
    padding: 4% 0;
    flex: 0 0 50%;
    color: $text_white;
  }

  .right {
    padding: 4% 0;
    flex: 0 0 50%;
    color: $text_dark;
  }

  .whole {
    padding: 4% 0;
    flex-grow: 1;
    color: $text_white;
  }
}
</style>

<script>
export default {
  props: ["color", "name", "left", "right", "title", "value", "single"],
  methods: {
    click: function (ev) {
      this.$emit("dialog_end", { confirm: ev, name: this.name, value: this.value });
    },
  },
  mounted: function () {
    let _that = this;
    window.setTimeout(function () {
      _that.$refs.dummy.focus();
    }, 1);
  },
};
</script>
